<template>
    <div>

                                    <div class="baiseback" style="min-height: 90vh">

                                         <p class="first_title hander" style="margin-top: 60px;"><b>个人主页</b></p>
                                        <router-link :to="'Home?type=myforum&authorId='+authorId"><p class="second_title hander"><i class="fa fa-file-o"></i>&nbsp;{{authorId==lander.uid?'我':'Ta'}}的文章</p></router-link>
                                        <router-link :to="'Comments?type=comments&authorId='+authorId"><p class="second_title hander"><i class="fa fa-comment-o"></i>&nbsp;{{authorId==lander.uid?'我':'Ta'}}的回复</p></router-link>
                                        <router-link :to="'Home?type=hit&authorId='+authorId"><p class="second_title hander"><i class="fa fa-thumbs-up"></i>&nbsp;{{authorId==lander.uid?'我':'Ta'}}的点赞</p></router-link>
                                        <router-link v-if="authorId==lander.uid" :to="'Home?type=collect&authorId='+authorId"><p class="second_title hander"><i class="fa fa-star-o"></i>&nbsp;{{authorId==lander.uid?'我':'Ta'}}的收藏</p></router-link>
                                        <router-link  v-if="authorId==lander.uid" :to="'Fans?type=att&authorId='+authorId"><p class="second_title hander"><i class="fa fa-user"></i>&nbsp;{{authorId==lander.uid?'我':'Ta'}}的关注</p></router-link>
                                        <router-link  v-if="authorId==lander.uid" :to="'Fans?type=fans&authorId='+authorId"><p class="second_title hander"><i class="fa fa-users"></i>&nbsp;{{authorId==lander.uid?'我':'Ta'}}的粉丝</p></router-link>

                                    </div>








    </div>


</template>
<script>



    export default {
        name: 'AuthorLeft',
        components: {},

        data() {
            return {



                lander: {},
                authorId:'',


            };
        },
        methods: {







        }, mounted() {

            this.lander = JSON.parse(this.$store.state.logininfo);


            // if(document.documentElement.scrollTop!=undefined)document.documentElement.scrollTop=0;
            // if(document.body.scrollTop!=undefined)document.body.scrollTop=0;




            if(this.$route.query.authorId!=undefined){
                this.authorId = this.$route.query.authorId;

            }


        }, watch:{
            $route:function(value){

                if(value.query.authorId!=undefined){
                    this.authorId=value.query.authorId;

                }


            }
        },
        activated() {



        },
        deactivated() {

        }

    };
</script>
<style scoped>
a{text-decoration: none;}

</style>
